import { render } from "./Google2faCodeForm.vue?vue&type=template&id=72c2d67e"
import script from "./Google2faCodeForm.vue?vue&type=script&lang=js"
export * from "./Google2faCodeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/Google2faCodeForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72c2d67e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72c2d67e', __exports__)) {
    api.reload('72c2d67e', __exports__)
  }
  
  module.hot.accept("./Google2faCodeForm.vue?vue&type=template&id=72c2d67e", () => {
    api.rerender('72c2d67e', render)
  })

}


export default __exports__